import React from "react";

export const CustomCheckbox = (props) => {

  const { isChecked, name, label, inline, id, onChange, ...rest } = props;
  const classes = inline !== undefined ? "checkbox checkbox-inline" : "checkbox";

  const handleChange = (event) => {
    console.log("Change", event)
    if (onChange)
      onChange(name, event.target.checked, id);
  }

  return (
    <div className={classes}>
      <input
        id={id ?? name}
        name={name}
        type="checkbox"
        onChange={handleChange}
        checked={isChecked}
        {...rest}
      />
      <label htmlFor={id ?? name}>{label}</label>
    </div>
  );
}